import React, { Suspense } from "react";
import { Routes, Route } from "react-router-dom";

import "../common/common.css";
import { Toast } from "primereact/toast";
import { setToastRef } from "../utils/toastService";
import { publicRoutes, protectedRoutes } from "../routes/routesConfig";
import ProtectedRoute from "../routes/ProtectedRoute";

const RestrictedRoutes = () => {
  return (
    <>
      <Toast ref={setToastRef} />
      <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          {publicRoutes.map(({ path, Component }) => (
            <Route key={path} path={path} element={<Component />} />
          ))}

          {protectedRoutes.map(({ path, Component }) => (
            <Route
              key={path}
              path={path}
              element={
                <ProtectedRoute>
                  <Component />
                </ProtectedRoute>
              }
            />
          ))}

          <Route path="*" element={null} />
        </Routes>
      </Suspense>
    </>
  );
};

export default RestrictedRoutes;
